/**
 * Palette-aligned ActionLink variants (see palette-design.md).
 * @typedef {'primary' | 'secondary' | 'trace' | 'danger' | 'soft' | 'ghost' | 'info'} ActionLinkVariant
 */

/** @type {Record<string, ActionLinkVariant>} */
export const ACTION_LINK_VARIANTS = {
  primary: "primary",
  secondary: "secondary",
  trace: "trace",
  danger: "danger",
  soft: "soft",
  ghost: "ghost",
  info: "info",
};

/** @deprecated Use `variant`. Legacy ActionLink `color` prop. */
export const LEGACY_COLOR_TO_VARIANT = {
  purple: "secondary",
  blue: "soft",
  green: "trace",
  red: "danger",
};

/**
 * @param {ActionLinkVariant | undefined} variant
 * @param {string | undefined} color
 * @returns {ActionLinkVariant}
 */
export function resolveActionLinkVariant(variant, color) {
  if (variant && ACTION_LINK_VARIANTS[variant]) {
    return variant;
  }
  if (color && LEGACY_COLOR_TO_VARIANT[color]) {
    return LEGACY_COLOR_TO_VARIANT[color];
  }
  return "secondary";
}
